import React, { MouseEvent, useEffect, useState } from 'react';
import classNames from 'classnames';
import { CaretRightOutlined } from '@easyv/react-icons';
import { isNil } from '@/utils';
import { findItemInTreeList } from '@/utils/treeList';
import { ROOT_FOLDER_ID, ROOT_OFFICIAL_FOLDER_ID, SelectedCategoryType } from '../..';
import { ROOT_CATEGORY_ID } from '@/constants/assetList';

interface OfficialAssetCategoryItemType {
  id: string;
  name: string;
  children: OfficialAssetCategoryItemType[];
}

interface OfficialAssetCategoryProps {
  className?: string;
  data: OfficialAssetCategoryItemType[];
  depth: number;
  selectedCate: SelectedCategoryType | null;
  onSelectFolder: (id: SelectedCategoryType) => void;
}

interface OfficialAssetCategoryItemProps {
  data: OfficialAssetCategoryItemType;
  depth: number;
  selectedCate: SelectedCategoryType | null;
  onSelectFolder: (id: SelectedCategoryType) => void;
}

export function OfficialAssetCategory({
  className,
  data,
  depth,
  selectedCate,
  onSelectFolder,
}: OfficialAssetCategoryProps) {
  return (
    <div className={className}>
      {data.map((item) => (
        <OfficialAssetCategoryItem
          key={item.id}
          depth={depth}
          selectedCate={selectedCate}
          data={item}
          onSelectFolder={onSelectFolder}
        />
      ))}
    </div>
  );
}

function OfficialAssetCategoryItem({
  selectedCate,
  data,
  depth,
  onSelectFolder,
}: OfficialAssetCategoryItemProps) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapsed = (e: MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    setIsCollapsed((prev) => !prev);
  };

  const isSelected = data.id === selectedCate?.id;

  // 如果工作目录是子孙目录或此目录，则展开
  useEffect(() => {
    if (isNil(selectedCate)) return;
    if (findItemInTreeList(data.children, (item) => item.id === selectedCate.id)) {
      setIsCollapsed(false);
    }
  }, [data, selectedCate]);

  return (
    <>
      <div
        className={classNames(
          isSelected
            ? 'bg-primary text-white cursor-default'
            : 'text-textColorBase cursor-pointer hover:text-white hover:bg-bgColorHover',
          'h-8 leading-0 align-middle px-3 relative group flex items-center justify-center',
        )}
        style={{
          paddingLeft: `${data.id === ROOT_CATEGORY_ID ? 12 + 16 : 12 + 16 * depth - 16}px`,
        }}
        onClick={() => {
          onSelectFolder(data);
        }}
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {data.id !== ROOT_CATEGORY_ID && (
          <div className='w-4 flex items-center justify-center'>
            {data?.children && data.children.length > 0 && (
              <div className='flex items-center justify-center' onClick={handleCollapsed}>
                <CaretRightOutlined
                  size={10}
                  className={classNames(
                    'cursor-pointer transition-transform duration-300 transform inline-flex text-content4 group-hover:text-white',
                    {
                      'rotate-90': !isCollapsed,
                    },
                  )}
                />
              </div>
            )}
          </div>
        )}
        <span className='flex-auto cursor-pointer truncate items-center inline-flex'>
          <span className='inline-block '>{data.name}</span>
        </span>
      </div>
      {data?.children && !isCollapsed && (
        <OfficialAssetCategory
          data={data.children}
          depth={++depth}
          selectedCate={selectedCate}
          onSelectFolder={onSelectFolder}
        />
      )}
    </>
  );
}
